import React, { useEffect, useState } from "react";
import { useStateValue } from '../../state';
import { Form, Row, Col, Input, Select, Divider, Button, Steps, Typography, Table, notification } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import api from '../../services/api';
import moment from "moment";
import { Data, FormGW, InputCpfCnpj, SelectPaginacao } from "../../components";
import { TabItens, TabFaturamento, TabFaturamentoNovo } from './tabPage';
import { MaskFormat, FormatNumber } from '../../ValueObjects/index';
import { manutencaoActions, selectPaginadoActions } from "../../actions";
import SelectPaginado from "../../components/selectPaginado";
import { validaForm, validarNumeros } from '../../services/funcoes';

export default function ManutencaoOrcamento({ formulario, aoSalvar, cliente, vendedor, showDrawerExtra, pages, proximaPag }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [tagPages, setTagPages] = useState(0);
    const [clientes, setClientes] = useState([]);
    const [listaProduto, setListaProduto] = useState([]);
    const [pessoaFisica, setPessoaFisica] = useState(1);
    const [orcamentoFormaPagamento, setOrcamentoFormaPagamento] = useState([]);
    const [permiteValidar, setPermiteValidar] = useState(true);
    const [pagina, setPagina] = useState(1);

    const listaValidacoesDest = [
    ];

    useEffect(() => {
        if (!!manutencao.dados) {
            if (!!manutencao.dados.orcamentoFormaPagamento) {
                setOrcamentoFormaPagamento(manutencao.dados.orcamentoFormaPagamento);
                carregarDados();
            }
            manutencao.dados.orc_datainclusao = moment(manutencao.dados.orc_datainclusao);
            manutencao.dados.orc_datavalidade = moment(manutencao.dados.orc_datavalidade);
            if (!!manutencao.dados.orc_id && listaProduto.length === 0) {
                carregarDados();
                buscarDadosOrcamento();
            }
            formulario.setFieldsValue(manutencao.dados);
        }
    }, [manutencao.dados])

    useEffect(() => {
        if (ui.showDrawer) {
            carregarDados();
            buscarDadosOrcamento();
            if (!(!!formulario.getFieldValue().orc_datainclusao)) {
                formulario.setFieldsValue({ orc_datainclusao: moment(new Date()) });
            }
            if (!!manutencao.dados) {
                let lista = [];
                if (lista.length > 0) dispatch({ type: selectPaginadoActions.CHANGE, data: lista });
                formulario.setFieldsValue(manutencao.dados);
            }
            if (!!!formulario.getFieldValue().ntf_dataemissao) {
                formulario.setFieldsValue({ ntf_dataemissao: moment(new Date()) });
            }
        }
    }, [ui.showDrawer]);

    useEffect(() => {
        carregarDados();
        buscarDadosOrcamento();
        carregarDadosCliente();
    }, []);

    function carregarDadosCliente() {
        api.get('Cliente/Listar').then(
            (res) => {
                setClientes(res.data);
            }
        ).catch(
            (erro) => {
                console.log(erro);
            }
        );
    };

    useEffect(() => {
        if ((!!proximaPag.proximaPag || proximaPag.proximaPag === 0) && permiteValidar) {
            validarTrocaPg(proximaPag.proximaPag);
        } else {
            setPermiteValidar(true);
        }
    }, [proximaPag.proximaPag]);

    function validarTrocaPg(pagina) {
        let paginaAtual = pages.tagPages;
        let listaValidacoes = [];
        switch (paginaAtual) {
            case 0:
                listaValidacoes = listaValidacoesDest;
                if (paginaAtual < pagina) {
                    var recebendo = listaProduto.map(function (e) { return e.ocp_qtdrecebendo });
                    var verifica = recebendo.reduce(function (verifica, i) {
                        return verifica + i;
                    });
                    if (!!listaProduto && verifica === 0) {
                        notification.warning({ message: 'Aviso', description: 'Nota Fiscal deve ter ao menos 1 item!' });
                        setPermiteValidar(false);
                        proximaPag.setProximaPag(paginaAtual);
                        return false;
                    }
                }
                break;
            case 1:
                if (paginaAtual < pagina) {
                    listaValidacoes = [];
                    setPermiteValidar(false);
                    proximaPag.setProximaPag(paginaAtual);
                    return false;
                }
                break;
        }
        if (validaForm(formulario, listaValidacoes)) {
            pages.setTagPages(pagina);
        } else {
            setPermiteValidar(false);
            proximaPag.setProximaPag(paginaAtual);
        }
    };

    async function buscarDadosCliente(registro) {
        if (!!registro) {
            let cliente = (await api.get(`Cliente/BuscarCliente/${registro}`)).data;
            if (!!cliente) {
                dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, ...{ destinatario: cliente } } } });
                formulario.setFieldsValue({ 'pej_inscricaoestadual': cliente.pej_inscricaoestadual });
                formulario.setFieldsValue({ 'pes_nome': cliente.pes_nome });
                formulario.setFieldsValue({ 'cli_id': cliente.cli_id });
                formulario.setFieldsValue({ 'cpfcnpj': (!cliente.pef_cpf ? cliente.pef_cpf : cliente.pej_cnpj) });
                formulario.setFieldsValue({ 'pef_cpf': cliente.pef_cpf });
                formulario.setFieldsValue({ 'pej_cnpj': cliente.pej_cnpj });
                setarCpfCnpj(cliente);
            } else {
                limparCliente();
            }
        } else {
            limparCliente();
        }
    };

    function limparCliente() {
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: { ...manutencao.dados, ...{ destinatario: null } } } });
        formulario.setFieldsValue({ 'pej_inscricaoestadual': null });
        formulario.setFieldsValue({ 'pes_nome': null });
        formulario.setFieldsValue({ 'cpfcnpj': null });
        formulario.setFieldsValue({ 'pef_cpf': cliente.pef_cpf });
        formulario.setFieldsValue({ 'pej_cnpj': cliente.pej_cnpj });
    }

    function setarCpfCnpj(cliente) {
        let cpfCnpj = '';
        if (cliente.pes_fisicajuridica > 0) {
            if (cliente.pes_fisicajuridica === 1) {
                cpfCnpj = cliente.pef_cpf;
                setPessoaFisica(1);
            } else if (cliente.pes_fisicajuridica === 2) {
                cpfCnpj = cliente.pej_cnpj;
                setPessoaFisica(2);
            } else if (cliente.pes_fisicajuridica === 3) {
                cpfCnpj = cliente.pes_idestrangeiro;
                setPessoaFisica(3);
            }
            formulario.setFieldsValue({ cpfcnpj: cpfCnpj });
        } else {
            notification.warn("Cliente informado com cadastro de pessoa física/jurídica/estrangeira incorreto!");
            formulario.setFieldsValue({ pes_id: null });
            return false;
        }
    };

    function carregarDados() {
        if (!!formulario.getFieldValue().orc_id) {
            api.get(`OrcamentoItem/DadosItem?orcamento=${formulario.getFieldValue().orc_id}`).then(
                (res) => {
                    let itens = res.data;
                    setListaProduto(itens);
                }
            ).catch(
                (erro) => {
                    console.log(erro);
                }
            )
        }
    };

    //////////////////////////////////////////////////////////////////
    function buscarDadosOrcamento() {
        api.get(`OrcamentoFormaPagamento/Listar?orcamento=${formulario.getFieldValue().orc_id}`).then(
            res => {
                let key = 1;
                res.data.forEach((itens) => {
                    itens.key = key++;
                })
                setOrcamentoFormaPagamento(res.data);
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    };

    function popularDadosItens() {
        let produtos = [];
        listaProduto.forEach(itens => {
            let aux = { ...itens };
            aux.orc_id = itens.orc_id;
            aux.pro_id = itens.pro_id;
            aux.oit_qtde = itens.oit_qtde;
            aux.data_sincro = new Date();
            aux.oit_valorunitario = itens.oit_valorunitario;
            aux.prg_id = itens.prg_id;
            aux.oit_desconto = itens.oit_desconto;
            aux.oit_id = itens.oit_id;
            produtos.push(aux);
        })
        return produtos;
    };

    function preencherDadosOrcamento() {
        let dadosForma = [];
        orcamentoFormaPagamento.forEach(forma => {
            let aux = { ...forma };
            aux.valorTotal = formulario.getFieldValue().valorTotal;
            aux.orc_id = formulario.getFieldValue().orc_id;
            aux.orc_numero = formulario.getFieldValue().orc_numero;
            aux.fpg_id = forma.fpg_id;
            aux.fpg_descricao = forma.fpg_descricao;
            aux.cpg_id = forma.cpg_id;
            aux.cpg_descricao = forma.cpg_descricao;
            aux.data_sincro = new Date();
            aux.orf_id = forma.orf_id;
            aux.cpg_descricao = forma.cpg_descricao;
            aux.orf_percentualdesconto = !!forma.orf_percentualdesconto ? forma.orf_percentualdesconto : 0;
            aux.orf_percentualacrescimo = !!forma.orf_percentualacrescimo ? forma.orf_percentualacrescimo : 0;
            dadosForma.push(aux);
        });
        return dadosForma;
    };

    async function salvarManutencao(values) {
        if (listaProduto.length > 0) {
            let dados = {};
            dados = { ...values };
            dados.orc_id = formulario.getFieldValue().orc_id;
            dados.ven_id = formulario.getFieldValue().ven_id;
            dados.cli_id = formulario.getFieldValue().cli_id;
            dados.orc_observacao = formulario.getFieldValue().orc_observacao;
            values.orc_valorfrete = parseFloat(values.orc_valorfrete);
            dados.orc_numero = formulario.getFieldValue().orc_numero;
            dados.orc_valordesconto = values.valorDesconto;
            dados.orc_valoroutros = values.orc_valoroutros;
            dados.orc_datainclusao = formulario.getFieldValue().orc_datainclusao;
            dados.orc_datavalidade = formulario.getFieldValue().orc_datavalidade;
            dados.orc_responsavelorcamento = formulario.getFieldValue().orc_responsavelorcamento;
            dados.orcamentoformapagamentos = preencherDadosOrcamento(orcamentoFormaPagamento);
            dados.orcamentoitens = popularDadosItens(listaProduto);
            try {
                var res = dados.orc_id ? await api.put('Orcamento/Editar', dados) : await api.post('Orcamento/Incluir', dados);
                if (res.status == 200) {
                    notification.success({ message: 'Operação concluída', description: "Os dados da Ordem de Compra foram salvos com sucesso!" });
                }
            } catch (error) {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(error.response) });
            } finally {
                carregarDados(true);
                aoSalvar();
            }
        } else {
            notification.warning({ message: 'Aviso!', description: 'É necessário informar pelo menos um item!' });
        }
    };

    return (
        <FormGW layout="vertical" form={formulario} name="manutencaoOrcamento" onFinish={salvarManutencao}>
            <Row gutter={[8, 0]}>
                <Col xs={24} sm={16} md={16} lg={10} xl={10}>
                    <Form.Item name="cli_id" label="Selecione um Cliente" rules={[{ required: true, message: 'Selecione um Cliente' }]}>
                        <SelectPaginacao url="Cliente/Listar"
                            placeholder="Selecione um Cliente"
                            form={formulario} nameLabel="cli_id" nameValue="cli_id" name="cli_id" selecionarRegUnico="cli_id" allowClear={true}
                            onChangeFunction={(dados) => buscarDadosCliente(dados)} conteudo={
                                cli => (<Select.Option value={cli.cli_id} key={cli.key}> {cli.pes_nome}<br />
                                    {(!!cli.pej_cnpj ? `CNPJ.: ${MaskFormat(cli.pej_cnpj, '', true)}` : !!cli.pef_cpf ? `CPF.: ${MaskFormat(cli.pef_cpf, '', true)}` : '')}
                                </Select.Option>)
                            } />
                    </Form.Item>
                    <Form.Item hidden name="pes_nome"></Form.Item>
                </Col>
                <Col xs={24} sm={6} md={6} lg={4} xl={4}>
                    {pessoaFisica === 1 &&
                        <InputCpfCnpj cpf label="CPF/CNPJ" name="pef_cpf" rules={[{ required: true, message: 'Informe o Cpf/Cnpj' }]} disabled />
                    }
                    {pessoaFisica === 2 &&
                        <InputCpfCnpj label="CPF/CNPJ" name="pej_cnpj" rules={[{ required: true, message: 'Informe o Cpf/Cnpj' }]} disabled />
                    }
                    {pessoaFisica === 3 &&
                        <InputCpfCnpj mask='00.000.000-0' label="CPF/CNPJ" name="cpfCnpj" rules={[{ required: true, message: 'Informe o Cpf/Cnpj' }]} disabled />
                    }
                </Col>
                <Col xs={24} sm={8} md={8} lg={4} xl={4}>
                    <Data label="Data de Emissão" name="orc_datainclusao" />
                </Col>
                <Col xs={24} sm={8} md={8} lg={4} xl={4}>
                    <Data label="Data de Validade" name="orc_datavalidade" />
                </Col>
            </Row>
            <Row gutter={[8, 0]}>
                <Col xs={24} sm={16} md={16} lg={10} xl={10}>
                    <Form.Item name="ven_id" label="Selecione o Vendedor">
                        <SelectPaginado url="Vendedor/Listar" placeholder="Selecione um Vendedor" form={formulario} name="ven_id"
                            conteudo={
                                v => (<Select.Option value={v.ven_id} key={v.key}>{v.pes_nome}</Select.Option>)
                            } />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={16} md={16} lg={10} xl={10}>
                    <Form.Item label="Responsável pelo Orçamento" name="orc_responsavelorcamento">
                        <Input placeholder="Informe um Responsável" />
                    </Form.Item>
                </Col>
            </Row>
            <Col span={24}>
                <Form.Item label="Observação" name="orc_observacao">
                    <Input.TextArea placeholder="Informe uma observação" />
                </Form.Item>
            </Col>
            <Row gutter={[0, 24]}>
                <Col span={24}>
                    <Steps size="small" type="navigation" onChange={(e) => setTagPages(e)} current={pages.tagPages}>
                        <Steps.Step title="Itens" />
                        <Steps.Step title="Valores" />
                    </Steps>
                </Col>
            </Row>
            <Row gutter={[8, 0]}>
                <Col span={24}>
                    {pages.tagPages === 0 &&
                        <TabItens
                            form={formulario}
                            dadosItens={{ listaProduto, setListaProduto }}
                        />
                    }
                    {pages.tagPages === 1 &&
                        <TabFaturamento
                            form={formulario}
                            dadosItens={listaProduto}
                            dadosVendedor={vendedor}
                            orcamento={{ orcamentoFormaPagamento, setOrcamentoFormaPagamento }}
                        />
                    }
                </Col>
            </Row>
        </FormGW>
    );

}